import React from 'react';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import IconButton from 'material-ui/IconButton';
import {Button} from "material-ui";

class ContextMenu extends React.Component {

    getTextSelecteds(count) {
        if (count === 1) {
            return '1 item selecionado'
        } else {
            return count + ' itens selecionados'
        }
    }

    render() {
        return (
            <AppBar position="fixed" color={'default'} style={{zIndex: 1200}} classes={{root: 'appbar'}}>
                <Toolbar className="toolbar">
                    <IconButton color="inherit" onClick={() => {this.props.uncheckAll()}}>
                        <i className="material-icons">arrow_back</i>
                    </IconButton>

                    <div className="title">
                        <Typography type="title" color="inherit">
                            <div>Voltar</div>
                        </Typography>
                    </div>

                    <div className={'count-selected'}>
                        {this.getTextSelecteds(this.props.selectedItems.length)}
                    </div>

                    <div className="app-action-buttons">
                        <Button color="primary" onClick={() => {this.props.finishSessions()}}>
                            Finalizar Sessões
                        </Button>
                    </div>
                </Toolbar>
            </AppBar>
        )
    }
}

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components/Monitoring/ContextMenu.js